var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import device from "@/core/device";
import { Controller } from "stimulus";
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.initialize = function () {
        console.log("[initialize] App");
    };
    default_1.prototype.connect = function () {
        console.log("[connect] App");
        this.element.classList.add(device.isPC ? "is-pc" : "is-sp");
        if (device.isIE) {
            this.element.classList.add("is-ie");
        }
        if (device.isEdge) {
            this.element.classList.add("is-edge");
        }
        if (device.isChrome) {
            this.element.classList.add("is-chrome");
        }
        if (device.isAndroid) {
            this.element.classList.add("is-android");
        }
        if (device.isIPadOS) {
            this.element.classList.add("is-ipados");
        }
        if (device.isIOS) {
            this.element.classList.add("is-ios");
        }
        this.onTouchmove = function (e) {
            e.preventDefault();
        };
        this.onClick = function (e) {
            console.log('click');
        };
        this.hashScroll();
        this.setAnaylticsEvents();
    };
    default_1.prototype.toggleMenu = function () {
        if (this.element.classList.contains("is-menu-open")) {
            // close
            this.element.classList.remove("is-menu-open");
            document.removeEventListener("click", this.onClick);
        }
        else {
            // open
            this.element.classList.add("is-menu-open");
            document.addEventListener("click", this.onClick, { passive: false });
        }
    };
    default_1.prototype.hashScroll = function () {
        if (!document.location.hash) {
            return;
        }
        var targetEl = document.getElementById(document.location.hash.substring(1));
        if (!targetEl) {
            return;
        }
    };
    default_1.prototype.setAnaylticsEvents = function () {
        var linkElements = document.querySelectorAll('a[target="_blank"]');
        linkElements.forEach(function (elm, index) {
            elm.addEventListener("click", function (e) {
                e.preventDefault();
                var targetUrl = elm.getAttribute("href"); // クリックしたa要素のhrefに指定されたURL
                var currentUrl = window.location.href; // 現在地のURL
                gtag('event', targetUrl, {
                    'event_category': 'outbound link',
                    'event_label': currentUrl,
                });
                if (targetUrl !== null)
                    window.open(targetUrl);
            });
        });
    };
    return default_1;
}(Controller));
export default default_1;
